import { BASE_URL } from '../Config';

/**
 * API 요청 함수
 * @param {string} endpoint - API 경로
 * @param {string} method - HTTP 메서드 (GET, POST 등)
 * @param {object} [data] - 요청에 포함할 데이터 (POST, PUT 등에서 사용)
 * @param {object} [config] - 부가 설정
 * @param {string} [config.token] - 관리자 JWT. 있으면 Authorization 헤더로 실어보냅니다.
 * @param {AbortSignal} [config.signal] - 요청 취소용 시그널
 * @returns {Promise<object>} - 서버 응답 데이터
 */
export const apiRequest = async (endpoint, method = "GET", data = null, config = {}) => {
    try {
        let url = `${BASE_URL}${endpoint}`;

        // GET 요청에서 쿼리 파라미터 추가
        if (method === "GET" && data) {
            const queryParams = new URLSearchParams(data).toString();
            url += `?${queryParams}`;
        }

        const options = {
            method,
            signal: config.signal,
            headers: {
                "Content-Type": "application/json",
                ...(config.token ? { Authorization: `Bearer ${config.token}` } : {}),
            },
        };

        // POST, PUT 등에서만 body 추가
        if (data && method !== "GET") {
            options.body = JSON.stringify(data);
        }

        const response = await fetch(url, options);

        if (!response.ok) {
            const errorText = await response.text();
            // 서버가 { message } 형태로 내려주면 그 문구를 그대로 화면에 쓸 수 있게 꺼내둡니다.
            let message = errorText;
            try {
                const parsed = JSON.parse(errorText);
                if (parsed && parsed.message) message = parsed.message;
            } catch (_) { /* JSON이 아니면 원문 사용 */ }

            const error = new Error(message || `Server Error: ${response.status}`);
            error.status = response.status;
            throw error;
        }

        return await response.json();
    } catch (error) {
        if (error.name === "AbortError") throw error;
        console.error(`Error in ${method} request to ${endpoint}:`, error);
        throw error;
    }
};
